import { createFileRoute, useParams } from "@tanstack/react-router";
import { EntityTypeFormTab } from "@/features/form-editor/components/entity-type-form-tab";

const ROUTE_ID =
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/jobTypes/$jobTypeId/schema" as const;

export const Route = createFileRoute(ROUTE_ID)({
	component: OrgJobTypeSchemaTab,
});

function OrgJobTypeSchemaTab() {
	const { orgId, jobTypeId } = useParams({ from: ROUTE_ID });
	return (
		<EntityTypeFormTab
			entity="job"
			typeId={jobTypeId}
			scope="org"
			orgId={orgId}
			mutationOrganizationId={orgId}
		/>
	);
}
